// extracted by mini-css-extract-plugin
export default {"root":"Box_root__LoWsq","color-default":"Box_color-default__sL+Tv","color-primary":"Box_color-primary__naXHF"};